export interface Author {
	slug: string;
	name: string;
	role: string;
	bio: string;
	avatar: string;
	email?: string;
	twitter?: string;
	linkedin?: string;
}

export const authors: Record<string, Author> = {
	'alex-turner': {
		slug: 'alexander-turner',
		name: 'Alexander Turner',
		role: 'Co-founder & CEO',
		bio: 'Alex is the CEO of Admiral. Previously, Alex has founded Ordnance Networks, Luma Networks and has worked in the global backbone engineering team at Amazon.',
		avatar: '/authors/alex.jpeg',
		email: 'alex@admrl.co',
		linkedin: 'alexanderpaulturner'
	},
	'dan-ward': {
		slug: 'daniel-ward',
		name: 'Daniel Ward',
		role: 'Co-founder & CTO',
		bio: 'Daniel runs engineering at Admiral and has a rich background in highly distributed linux systems across infrastructure and finance.',
		avatar: '/authors/dan.jpeg',
		email: 'daniel@admrl.co',
		linkedin: 'daniel-n-ward'
	}
};

export function getAuthor(slug: string): Author | undefined {
	return authors[slug];
}
